import { react, useState, useEffect } from 'react';
import TokenService from '../../services/TokenService';

export default function LinkedCharity() {

    const [requestedCharity, setRequesedCharity] = useState(null);

    useEffect(() => {
        let queryParams = new URLSearchParams(window.location.search);
        let requesedCharity = queryParams.get("charity");

        if (requesedCharity != null) {
            var postData = {
                tag: requesedCharity
            }

            
            TokenService.post(postData, 'GetCharity', '')
                .then((response) => {



                    if (response !== null) {
                      
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            let jsonData = JSON.parse(response.JsonData);
                            setRequesedCharity(jsonData);
                        }
                    }
                })
                .catch((response) => {
                   
                });
        }
    }, []);

    if (requestedCharity != null) {
        return <div style={{ backgroundColor: 'var(sipzee-grey-3)', display: 'flex', borderBottom:'3px solid var(--sipzee-green)', padding:'10px', justifyContent:'center' }}>
            {requestedCharity.CompanyType == "Charity" ?
                <div style={{ borderRadius: '50%', height: '75px', width: '75px', border: '3px solid black', alignSelf: 'center', marginRight: '10px', boxShadow: '3px 3px 5px 0px rgba(0, 0, 0, 0.5)', backgroundColor: 'var(--paper-root)' } }>
                    <img src='/images/DonateIcon.png' style={{ height: '50px', width: '50px', position:'relative', left:'-2px', top:'8px' }} />
                </div>
        :
                <div style={{ borderRadius: '50%', height: '75px', width: '75px', border: '3px solid black', alignSelf: 'center', marginRight: '10px', boxShadow: '3px 3px 5px 0px rgba(0, 0, 0, 0.5)', backgroundColor:'var(--paper-root)' }}>
                    <img src='/images/FundraiserIcon.png' style={{ height: '50px', width: '50px', position: 'relative', left: '-5px', top: '7px' }} />
                </div>
        }
            <div style={{ fontWeight: 'bold', alignSelf: 'center', fontSize: 'calc(.8em + 1vw)' }}>{requestedCharity.DonationTitle}</div>
            {requestedCharity.Images.length > 0 ?
                <img src={requestedCharity.Images[0].ImagePath} style={{ height: '80px', boxShadow: '3px 3px 5px 0px rgba(0, 0, 0, 0.5)', marginLeft:'10px' }} />
                :
                null
            }
        </div>
    }
   
}